import { OutlinedInput, OutlinedInputProps, SxProps, Theme } from "@mui/material"
import { useEffect, useState } from "react"
import Stack from "../stack"
import Label from "../label"

const DebouncedInput = ({
  value: initialValue,
  onChange,
  debounce = 500,
  error,
  required,
  labelMb,
  label,
  labelWeight,
  labelColor,
  labelSx,
  ...props
}: {
  value: string | number
  onChange: (value: string | number) => void
  debounce?: number
  labelMb?: number
  label?: string
  labelWeight?: number
  labelColor?: string
  labelSx?: SxProps<Theme>
} & Omit<OutlinedInputProps, "onChange">) => {
  const [value, setValue] = useState(initialValue)

  useEffect(() => {
    setValue(initialValue)
  }, [initialValue])

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (value !== initialValue) {
        onChange(value)
      }
    }, debounce)

    return () => clearTimeout(timeout)
  }, [value, initialValue])

  return (
    <Stack sx={{ width: props.fullWidth ? "100%" : undefined }}>
      <Label
        mb={labelMb}
        label={label}
        labelWeight={labelWeight}
        labelColor={(labelColor ?? error) ? "error" : labelColor}
        required={required}
        labelSx={labelSx}
      />
      <OutlinedInput {...props} value={value} onChange={(e) => setValue(e.target.value)} />
    </Stack>
  )
}

export default DebouncedInput
